Jelly.Payments.Correct_Amount = function(Parameters)
{	
	// Get namespace
	var Namespace = Parameters["Namespace"];

	// Get input val
	var Value = parseFloat(Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + "input").val());
		
	// If the value is not blank
	if (!isNaN(Value))
	{
		var Adjusted_Minimum = parseFloat(Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input_Description" + " " + ".Price").html());

		if (Value < Adjusted_Minimum)
		{
			Value = Adjusted_Minimum;
			Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + "input").val(Value).change();
		}
	}
};